import { Capacitor } from '@capacitor/core'
import { useEffect, useState } from 'react'

interface PlatformDetectionState {
  isNative: boolean
  isWeb: boolean
  isIOS: boolean
  isAndroid: boolean
  isMobileWeb: boolean
}

export const usePlatformDetection = (): PlatformDetectionState => {
  const [state, setState] = useState<PlatformDetectionState>({
    isNative: false,
    isWeb: true,
    isIOS: false,
    isAndroid: false,
    isMobileWeb: false,
  })

  useEffect(() => {
    const isNative = Capacitor.isNativePlatform()
    const isIOS = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent)
    const isAndroid = /Android/.test(navigator.userAgent)
    const isWeb = !isNative
    const isMobileWeb = isWeb && (isIOS || isAndroid)

    setState({
      isNative,
      isWeb,
      isIOS,
      isAndroid,
      isMobileWeb,
    })
  }, [])

  return state
}
